export default __webpack_public_path__ + "static/media/v03.c6b59f19.jpg";